module.exports = __webpack_public_path__ + "static/InterFaceXBold-Italic-50b91b60e06574aabd42974922106b55.woff";